// user
export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_TOKEN_LOGIN_REQUEST = 'USER_TOKEN_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
export const USER_SIGN_OUT = 'USER_SIGN_OUT';
export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST';
export const USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE';
export const USER_SET_DATA = 'USER_SET_DATA';
export const GET_USER_DATA_REQUEST = 'GET_USER_DATA_REQUEST';

// warranties
export const WARRANTIES_FETCH_REQUEST = 'WARRANTIES_FETCH_REQUEST';
export const WARRANTIES_FETCH_SUCCESS = 'WARRANTIES_FETCH_SUCCESS';
export const WARRANTIES_FETCH_FAILURE = 'WARRANTIES_FETCH_FAILURE';

// message
export const MESSAGE_SET_MESSAGE = 'MESSAGE_SET_MESSAGE';
export const MESSAGE_HIDE_MESSAGE = 'MESSAGE_HIDE_MESSAGE';

// contests
export const CONTESTS_FETCH_REQUEST = 'CONTESTS_FETCH_REQUEST';
export const CONTESTS_FETCH_SUCCESS = 'CONTESTS_FETCH_SUCCESS';

// coupons
export const COUPONS_FETCH_REQUEST = 'COUPONS_FETCH_REQUEST';
export const COUPONS_FETCH_SUCCESS = 'COUPONS_FETCH_SUCCESS';
export const COUPONS_FETCH_ERROR = 'COUPONS_FETCH_ERROR';
